import React from 'react';
import { View } from 'react-native';
import { ListItem } from '../../Core/List/ListItem';
import { Typography } from '../../Core/Typography/Typography';
import { IconProps } from '../../Icons/Icons.types';
import { cn } from '../../lib/utils';

export type OrderTypeListItemType = {
  iconComponent?: React.ElementType;
  iconProps?: IconProps;
  subtitle: string;
  title: string;
  onPress?: () => void;
  className?: string;
};

export const OrderTypeListItem = ({
  iconComponent: IconComponent,
  iconProps,
  subtitle,
  title,
  onPress,
  className,
}: OrderTypeListItemType) => {
  return (
    <ListItem className={className} onPress={onPress} pressable>
      <View className="mr-4 justify-center">
        {IconComponent && (
          <IconComponent
            {...iconProps}
            className={cn(
              'stroke-primary group-active:stroke-white',
              iconProps?.className,
            )}
          />
        )}
      </View>
      <View className="flex-1 flex-column justify-center">
        <Typography variant="callToAction">{title}</Typography>
        <Typography size="small" className="text-neutral-300">
          {subtitle}
        </Typography>
      </View>
    </ListItem>
  );
};
